import _styled from "styled-components";
import React from "react";
import { formatTemperature } from "../../utils/formatTemperature";
import { ReactComponent as IconMinus } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/minuscircleblue.svg";
import { ReactComponent as IconPlus } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/pluscircleblue.svg";
var sizeIconPlusMinus = 50;
var sizeIconMode = 48;

var RowContainer = _styled.div.withConfig({
  displayName: "ModeRow__RowContainer",
  componentId: "sc-1v3o9ux-0"
})(["margin-top:45px;display:flex;width:360px;justify-content:space-between;pointer-events:", ";opacity:", ";@media screen and (max-width:419px){width:320px;}"], function (p) {
  return p.disabled ? "none" : "auto";
}, function (p) {
  return p.disabled ? 0.3 : 1;
});

var ModeControl = _styled.div.withConfig({
  displayName: "ModeRow__ModeControl",
  componentId: "sc-1v3o9ux-1"
})(["display:flex;width:230px;justify-content:space-between;align-items:center;@media screen and (max-width:419px){width:190px;}"]);

var IconLabel = _styled.div.withConfig({
  displayName: "ModeRow__IconLabel",
  componentId: "sc-1v3o9ux-2"
})(["margin-top:5px;text-align:center;font-size:22px;"]);

var IconButton = _styled.button.withConfig({
  displayName: "ModeRow__IconButton",
  componentId: "sc-1v3o9ux-3"
})(["background:none transparent;border:0 none;padding:0;display:inline-block;&:focus{outline:0 none;}svg{display:block;}"]);

var IconSymbolContainer = _styled.div.withConfig({
  displayName: "ModeRow__IconSymbolContainer",
  componentId: "sc-1v3o9ux-4"
})(["display:flex;flex-direction:column;align-items:center;width:75px;"]);

var CurrentValue = _styled.div.withConfig({
  displayName: "ModeRow__CurrentValue",
  componentId: "sc-1v3o9ux-5"
})(["font-size:22px;"]);

export function ModeRow(_ref) {
  var Icon = _ref.icon,
      label = _ref.label,
      current = _ref.current,
      min = _ref.min,
      max = _ref.max,
      onChange = _ref.onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var decrementDisabled = min >= current;
  var incrementDisabled = max <= current;

  var handleDecrementClick = function handleDecrementClick() {
    if (decrementDisabled) return;
    onChange(Math.min(current - 1, max));
  };

  var handleIncrementClick = function handleIncrementClick() {
    if (incrementDisabled) return;
    onChange(Math.max(current + 1, min));
  };

  return /*#__PURE__*/React.createElement(RowContainer, {
    disabled: disabled
  }, /*#__PURE__*/React.createElement(IconSymbolContainer, null, /*#__PURE__*/React.createElement(Icon, {
    height: sizeIconMode,
    width: sizeIconMode
  }), /*#__PURE__*/React.createElement(IconLabel, null, label)), /*#__PURE__*/React.createElement(ModeControl, null, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleDecrementClick
  }, /*#__PURE__*/React.createElement(IconMinus, {
    fillOpacity: decrementDisabled ? 0.5 : 1,
    height: sizeIconPlusMinus,
    width: sizeIconPlusMinus
  })), /*#__PURE__*/React.createElement(CurrentValue, null, formatTemperature(current)), /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleIncrementClick
  }, /*#__PURE__*/React.createElement(IconPlus, {
    fillOpacity: incrementDisabled ? 0.5 : 1,
    height: sizeIconPlusMinus,
    width: sizeIconPlusMinus
  }))));
}